import { Component } from '@angular/core';
import moment from 'moment';
import { TranslatePipe } from '../../pipes/translate.pipe';

@Component({
  selector: 'copyright',
  templateUrl: 'copyright.component.html',
  styleUrls: ['copyright.component.scss'],
  standalone: true,
  imports: [TranslatePipe],
})
export class CopyrightComponent {
  public currentYear: string = moment().format('YYYY');
}
